module.exports = __webpack_public_path__ + "static/img/header-mobile.5a3fb3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-mobile.svg
// module id = 2Zj9
// module chunks = 0